import { render, staticRenderFns } from "./RelationLogistics.vue?vue&type=template&id=7cbccc9c&"
import script from "./RelationLogistics.vue?vue&type=script&lang=js&"
export * from "./RelationLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports